define('persistence/repositories/liveReceptionistOnboardingRepository',[
    'common/promises/promiseFactory',
    'externalDependencies/clientWebSocket'
], function () {
    const APPLICATION_NAME = `liveReceptionistOnboarding`;

    return function() {
        const self = this;

        const PromiseFactory = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactory();

        const ClientWebSocket = require('externalDependencies/clientWebSocket');
        const _liveReceptionistOnboardingSocket = ClientWebSocket.forApplication(APPLICATION_NAME);

        const WebSocketAppConstructor = require('persistence/webSocket/webSocketApp');
        const _liveReceptionistOnboardingWebSocketApp = new WebSocketAppConstructor();
        _liveReceptionistOnboardingWebSocketApp.init('live_receptionist_onboarding');

        const _subscribe = (eventName, callBack) => {
            _liveReceptionistOnboardingSocket.subscribeToEvent(eventName, callBack);
        };

        const _send = (command, parameters) => {
            return _promiseFactory.deferIndefinitely((deferred) => {
                _liveReceptionistOnboardingSocket.send(command, parameters || {}, (response, errMsg) => {
                    if (errMsg) {
                        deferred.reject(new Error(errMsg));
                        return;
                    }

                    deferred.resolve(response);
                });
            });
        };

        const _sendToWebsocket = (command, parameters) => {
            return _promiseFactory.deferIndefinitely((deferred) => {
                _liveReceptionistOnboardingWebSocketApp.send(command, parameters || {}, (result) => {
                    deferred.resolve(result);
                });
            });
        };

        self.checkIsEligibleForOnboarding = () => {
            return _send('checkIsEligibleForOnboarding', {});
        };

        self.createLiveReceptionistOnboarding = () => {
            return _send('createLiveReceptionistOnboarding', {});
        };

        self.getLiveReceptionistOnboarding = () => {
            return _send('getLiveReceptionistOnboarding', {});
        };

        self.getAffiliate = () => {
            return _send('getAffiliate', {});
        };

        self.getPATLivePhoneNumber = () => {
            return _send('getPATLivePhoneNumber', {});
        };

        self.getBillingAddress = () => {
            return _send('getBillingAddress', {});
        };

        self.updateWelcomeInfoCapture = () => {
            return _sendToWebsocket('updateWelcomeInfoCapture', {});
        };

        self.saveAccountBusinessName = (liveReceptionistOnboardingId, accountBusinessName) => {
            return _send('saveAccountBusinessName', { liveReceptionistOnboardingId, accountBusinessName });
        };

        self.saveBusinessName = (liveReceptionistOnboardingId, businessName) => {
            return _send('saveBusinessName', { liveReceptionistOnboardingId, businessName });
        };

        self.saveAddressLineOne = (liveReceptionistOnboardingId, addressLineOne) => {
            return _send('saveAddressLineOne', { liveReceptionistOnboardingId, addressLineOne });
        };

        self.saveAddressLineTwo = (liveReceptionistOnboardingId, addressLineTwo) => {
            return _send('saveAddressLineTwo', { liveReceptionistOnboardingId, addressLineTwo });
        };

        self.saveCity = (liveReceptionistOnboardingId, city) => {
            return _send('saveCity', { liveReceptionistOnboardingId, city });
        };

        self.saveRegion = (liveReceptionistOnboardingId, countryCode, regionCode) => {
            return _send('saveRegion', { liveReceptionistOnboardingId, countryCode, regionCode });
        };

        self.savePostalCode = (liveReceptionistOnboardingId, countryCode, postalCode) => {
            return _send('savePostalCode', { liveReceptionistOnboardingId, countryCode, postalCode });
        };

        self.saveTimeZone = (liveReceptionistOnboardingId, timeZone) => {
            return _send('saveTimeZone', { liveReceptionistOnboardingId, timeZone });
        };

        self.saveBusinessHours = (liveReceptionistOnboardingId, dayOfWeek, openTime, closeTime) => {
            return _send('saveBusinessHours', { liveReceptionistOnboardingId, dayOfWeek, openTime, closeTime });
        };

        self.resetBusinessHours = (liveReceptionistOnboardingId) => {
            return _send('resetBusinessHours', { liveReceptionistOnboardingId });
        };

        self.saveBusinessDescription = (liveReceptionistOnboardingId, description) => {
            return _send('saveBusinessDescription', { liveReceptionistOnboardingId, description });
        };

        self.saveTeamMembers = (liveReceptionistOnboardingId, teamMembers) => {
            return _send('saveTeamMembers', { liveReceptionistOnboardingId, teamMembers });
        };

        self.saveMessageRecipients = (liveReceptionistOnboardingId, messageRecipients) => {
            return _send('saveMessageRecipients', { liveReceptionistOnboardingId, messageRecipients });
        };

        self.saveSmsRecipients = (liveReceptionistOnboardingId, smsRecipients) => {
            return _send('saveSmsRecipients', { liveReceptionistOnboardingId, smsRecipients });
        };

        self.saveIndustry = (liveReceptionistOnboardingId, industry) => {
            return _send('saveIndustry', { liveReceptionistOnboardingId, industry });
        };

        self.saveNumberOfEmployees = (liveReceptionistOnboardingId, numberOfEmployees) => {
            return _send('saveNumberOfEmployees', { liveReceptionistOnboardingId, numberOfEmployees });
        };

        self.saveAgentTone = (liveReceptionistOnboardingId, agentTone) => {
            return _send('saveAgentTone', { liveReceptionistOnboardingId, agentTone });
        };

        self.savePhoneNumber = (liveReceptionistOnboardingId, phoneNumber) => {
            return _send('savePhoneNumber', { liveReceptionistOnboardingId, phoneNumber });
        };

        self.saveFaxNumber = (liveReceptionistOnboardingId, faxNumber) => {
            return _send('saveFaxNumber', { liveReceptionistOnboardingId, faxNumber });
        };

        self.saveEmailAddress = (liveReceptionistOnboardingId, emailAddress) => {
            return _send('saveEmailAddress', { liveReceptionistOnboardingId, emailAddress });
        };

        self.saveWebsiteUrl = (liveReceptionistOnboardingId, websiteUrl) => {
            return _send('saveWebsiteUrl', { liveReceptionistOnboardingId, websiteUrl });
        };

        self.saveMayForwardFromNumbers = (liveReceptionistOnboardingId, mayForwardFromNumbers) => {
            return _send('saveMayForwardFromNumbers', { liveReceptionistOnboardingId, mayForwardFromNumbers });
        };

        self.saveNumberIntentSelection = (liveReceptionistOnboardingId, numberIntentSelection) => {
            return _send('saveNumberIntentSelection', { liveReceptionistOnboardingId, numberIntentSelection });
        };

        self.saveCallerFollowUp = (liveReceptionistOnboardingId, callerFollowUp) => {
            return _send('saveCallerFollowUp', { liveReceptionistOnboardingId, callerFollowUp });
        };

        self.saveCallerFollowUpOther = (liveReceptionistOnboardingId, callerFollowUpOther) => {
            return _send('saveCallerFollowUpOther', { liveReceptionistOnboardingId, callerFollowUpOther });
        };

        self.saveOnboardingInformation = (liveReceptionistOnboardingId, information) => {
            return _send('saveOnboardingInformation', Object.assign({ liveReceptionistOnboardingId }, information));
        };

        self.saveOnboardingStatus = (liveReceptionistOnboardingId, onboardingStatus) => {
            return _send('saveOnboardingStatus', { liveReceptionistOnboardingId, onboardingStatus });
        };

        //#region Subscriptions

        self.onLiveReceptionistOnboardingCompleted = (callBack) => {
            _subscribe(`liveReceptionistOnboardingComplete`, callBack);
        };

        //#endregion

        self.dispose = () => {
            _liveReceptionistOnboardingSocket.disposeOfEvents();
        };
    };
});
